import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useTheme } from "@mui/material/styles";
import { Box, Skeleton, Typography } from "@mui/material";
import { headerSty, contentSty } from "../table-styles";
import { MedicEmploymentProps } from "../../interface/medic";
import {
  formatDateFromString,
} from "../../utils/url-id";


export default function MedicEmploymentHistory({
  medicEmployment,
  loading,
}: {
  medicEmployment: MedicEmploymentProps[];
  loading: boolean;
}) {
  const theme = useTheme();
  const headStyles = { ...headerSty, color: theme.palette.neutral.main };
  const contentStyles = { ...contentSty };
  return (
    <TableContainer
      component={Paper}
      sx={{
        width: "100%",
        mx: "auto",
        borderRadius: "16px",
        boxShadow: "none",
      }}
    >
      <Table
        sx={{ width: "98%", mx: "auto" }}
        size="small"
        aria-label="a dense table"
      >
        <TableHead>
          <TableRow>
            <TableCell sx={{ ...headStyles, textAlign: "left" }}>
              Hospital
            </TableCell>
            <TableCell sx={{ ...headStyles, textAlign: "left" }}>
              Department
            </TableCell>
            <TableCell sx={{ ...headStyles, textAlign: "left" }}>
              Start Date{" "}
            </TableCell>
            <TableCell sx={{ ...headStyles, textAlign: "left" }}>
              End Date{" "}
            </TableCell>
            <TableCell sx={{ ...headStyles, textAlign: "left" }}>
              Employment Type
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {medicEmployment.map((row) => (
            <TableRow
              key={row._id}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell
                sx={{ ...contentStyles, textAlign: "left", padding: "12px" }}
                component="th"
                scope="row"
              >
                {row?.facility_info?.name}
              </TableCell>
              <TableCell
                sx={{ ...contentStyles, textAlign: "left", padding: "12px" }}
              >
                {row?.employment_details?.positon}
              </TableCell>
              <TableCell
                sx={{ ...contentStyles, textAlign: "left", padding: "12px" }}
              >
                {!!row?.employment_details?.start_date
                  ? formatDateFromString(row?.employment_details?.start_date)
                  : "-"}
              </TableCell>
              <TableCell
                sx={{ ...contentStyles, textAlign: "left", padding: "12px" }}
              >
                {!!row?.employment_details?.end_date
                  ? formatDateFromString(row?.employment_details?.end_date)
                  : "-"}
              </TableCell>
              <TableCell
                sx={{ ...contentStyles, textAlign: "left", padding: "12px" }}
              >
                {row?.job_info?.employment_type}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {medicEmployment?.length === 0 && !loading && (
        <Box
          sx={{
            height: 200,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h4"
            sx={{ fontWeight: 600, color: theme.palette.neutral.main }}
          >
            No Employment Available.
          </Typography>
        </Box>
      )}
      {loading && (
        <Box sx={{ width: "96%", mx: "auto" }}>
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={60}
            sx={{ my: 2 }}
          />
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={60}
            sx={{ my: 2 }}
          />
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={60}
            sx={{ my: 2 }}
          />
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={60}
            sx={{ my: 2 }}
          />
        </Box>
      )}
    </TableContainer>
  );
}
